import { Card, CardContent } from '../../components/ui/card';
import { ConcessionActionLog } from '../../lib/api';
import { useFormatters } from '../../contexts/PreferencesContext';

interface HistoryTabProps {
  actionLogs: ConcessionActionLog[];
}

export function HistoryTab({ actionLogs }: HistoryTabProps) {
  const { formatDateTime } = useFormatters();

  return (
    <Card>
      <CardContent className="pt-6">
        {actionLogs.length === 0 ? (
          <p className="text-muted-foreground text-center py-4">No history available</p>
        ) : (
          <div className="space-y-4">
            {actionLogs.map((log) => (
              <div key={log.id} className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg">
                <div className="flex-1">
                  <p className="font-medium text-sm">{log.action_description}</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {log.performed_by_name || 'System'} - {formatDateTime(log.performed_at)}
                  </p>
                  {log.old_value && log.new_value && (
                    <p className="text-xs text-muted-foreground">
                      Changed from "{log.old_value}" to "{log.new_value}"
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
